import { getMention } from "components/util/schema_form/fields/rich_text/Editor.lib";


const htmlToPlainContent = (html = "") => {
  const dataRegex = /data-id="[^"]*"/g;
  let tempValue = html;
  let dataMatches = tempValue.match(dataRegex) ?? [];

  for (let dataMatch of dataMatches) {
    let dataSearch = tempValue.search(dataMatch);
    let prevTagHtmlPos = tempValue.substring(0, dataSearch).lastIndexOf("<")
    let dataId = dataMatch.replace("data-id=\"", "").slice(0, -1)
    tempValue = tempValue.substring(0, prevTagHtmlPos) + dataId + tempValue.substring(prevTagHtmlPos)
    tempValue = tempValue.replace(dataMatch, "")
  }

  tempValue = tempValue.replace(/<span((?!<\/span).)*/g, '')
  tempValue = tempValue.replace(/<li[^>]*><p[^>]*>/g, '\n  - ')
  tempValue = tempValue.replace(/<p[^>]*>/g, '\n')
  tempValue = tempValue.replace(/<[^>]*>/g, '')
  tempValue = tempValue.trim()

  return tempValue;
}

const plainToHtmlContent = (plain, nodes, collections, datatypes) => {
  if (plain == "") return ""
  
  let result = ""
  const mentionRegex = /[@#][^\s]+/g;
  let tempValue = plain ?? "";
  tempValue = tempValue.split("\n")
    .filter(x => x.length > 0)
    .map(t => `<p>${t}</p>`)
    .join("")
  let positionRegex;
  do {
    positionRegex = tempValue.search(mentionRegex)
    if (positionRegex != -1) { // Has mentions
      const valueRegex = tempValue.match(mentionRegex)[0]
      const mention = getMention(valueRegex, nodes, collections, datatypes)

      result += tempValue.substring(0, positionRegex)
      if (mention)
        result += `
          <span 
              type="variable" 
              data-type="mention" 
              class="variable" 
              data-id="${mention.id}"
              data-label="${mention.label}">
              ${mention.label}
          </span>
      `
      tempValue = tempValue.substring(positionRegex + valueRegex.length)
    } else result += tempValue
  } while (positionRegex != -1)

  return result;
}

export { htmlToPlainContent, plainToHtmlContent }